import { Link } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    why: 'price.cart.notifications.banner.why',
};

const ShowAlertButton: TranslatedComponent<{ onClick: VoidFunction }> = ({ onClick, trls }) => {
    return (
        <Link onClick={onClick} style="neutral" typography="subtitle-1-semibold" inline>
            {trls[TrlKeys.why]}
        </Link>
    );
};

export default translation(ShowAlertButton);
